import AOS from 'aos';

export default new class Animation {
  constructor(){
    this.handler();
  }
  handler(){
    AOS.init({
      duration: 2000
    });
  }
}();
